/**
 * Returns the first element that is a descendant of the root element
 * that matches the specified selector, or group of selectors.
 *
 * @param s The selector to query the DOM with.
 * @return The first matching element or null if no element found.
 */
export const select = (s: string): HTMLElement | null => {
  if (!s) {
    console.warn("[select]: No selector provided.");
    return null;
  }
  return document.querySelector(s);
};

/**
 * Returns a NodeList of elements that are descendants of the root element
 * and match the specified selector, or group of selectors.
 *
 * @param s The selector to query the DOM with.
 * @return A NodeList of matching elements.
 */
export const selectAll = (s: string): NodeListOf<Element> | any[] => {
  if (!s) {
    console.warn("[selectAll]: No selector provided.");
    return [];
  }
  return document.querySelectorAll(s);
};

/**
 * Creates a new HTML element with the specified tag name.
 *
 * @param element The tag name of the HTML element to create.
 * @param options An object containing the options for the new element.
 * @return The newly created HTML element.
 */
export const create = <K extends keyof HTMLElementTagNameMap>(
  element: K,
  options?: ElementCreationOptions,
): HTMLElementTagNameMap[K] | null => {
  if (!element) {
    console.warn("[create]: No element provided.");
    return null;
  }
  return document.createElement(element, options);
};
